import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { IpnLinkingPage } from '@/areas/components/IpnLinkingPage/IpnLinkingPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/components/linking')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({
        ipnId: 'optional',
        q: 'optional',
        rawSpecId: 'optional',
        'part-search': 'optional',
        'custom-part-search': 'optional',
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const ipnId = Route.useSearch({ select: (search) => search.ipnId });
    const rawSpecId = Route.useSearch({ select: (search) => search.rawSpecId });
    return <IpnLinkingPage ipnId={ipnId} rawSpecId={rawSpecId} />;
}
